import {isBot} from "./user/ui/utils";
import {getContainer} from "./ioc/IOCSetup";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "./RootReducer";
import {useEffect} from "react";
import {updateCountry, updateJurisdiction} from "./settings/SettingsActions";


export const CountryBlock = () => {
    const dispatch = useDispatch();
    useEffect(()=>{
        if(!isBot(navigator.userAgent)) {
            try {
                let urlParams = new URLSearchParams(window.location.search);
                if(urlParams.get("skipGeoIpCheck") === "true" || localStorage.getItem("skipGeoIpCheck") != null) {
                    localStorage.setItem('skipGeoIpCheck', 'true');
                } else {
                    getContainer().getGeoIpService().getCountryInfo().then((info) => {
                        localStorage.setItem("countryCode", info.countryCode ||"");
                        dispatch(updateJurisdiction(String(info.jurisdiction?.id ||"")));
                        let activeLocale = getContainer().getSettingsService().getActiveLocale();
                        if(info.blocked && !window.location.pathname.startsWith(`/${activeLocale.code}/blocked`)) {
                            window.history.replaceState(null,"",`/${activeLocale.code}/blocked/${info.countryName}`);
                            window.history.go();
                        } else if(info.countryCode) {
                            dispatch(updateCountry(info.countryCode));
                        }
                    });
                }
            } catch (e) {
                console.log("Error fetching geo ip", e);
            }
        }
    },[dispatch])

    return <></>
}